import React from 'react';
import Toolbar from '@material-ui/core/Toolbar';

import evapolarLogo from '../../../media/evapolar-logo.svg';
import { HideOnScroll } from '../hide-on-scroll';

import { AppBar, Wrapper, Logo, HelpCenterLink } from './styled';

export const Header = () => (
  <HideOnScroll>
    <AppBar>
      <Toolbar>
        <Wrapper>
          <a href="https://evapolar.com/">
            <Logo src={evapolarLogo} alt="Evapolar" />
          </a>
          <HelpCenterLink href="https://support.evapolar.com/">
            Help Center
          </HelpCenterLink>
        </Wrapper>
      </Toolbar>
    </AppBar>
  </HideOnScroll>
);
